<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col cols="12">
            <div class="form-base__title">
              Прошу обеспечить доказательства в виде осмотра информации,
              находящейся в информационно-телекоммуникационной сети "Интернет"
            </div>
          </v-col>
          <v-col cols="12" class="pb-0">
            <v-text-field
              label='Адрес в информационно-телекоммуникационной сети "Интернет", по которому находится информация, требующая осмотра'
              outlined
              class="text-error-h30"
              v-model="$v.securityEvidenceDetails.infoLocatedUrl.$model"
              :errorMessages="
                getValidationErrorText(
                  $v.securityEvidenceDetails.infoLocatedUrl
                )
              "
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Сведения (учетные данные и другие данные), необходимые для доступа к этой информации"
              outlined
              v-model="$v.securityEvidenceDetails.accessInfo.$model"
              :errorMessages="
                getValidationErrorText($v.securityEvidenceDetails.accessInfo)
              "
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              label="Информация, подлежащая осмотру, ее объем и особенности доступа к информации"
              outlined
              v-model="$v.securityEvidenceDetails.informationExamined.$model"
              :errorMessages="
                getValidationErrorText(
                  $v.securityEvidenceDetails.informationExamined
                )
              "
            />
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import { maxLength, required, url } from 'vuelidate/lib/validators';

import { checkInvalid, leaveStep } from '@/utils/services';
import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import { SecuringEvidenceStep } from '@/constants';

export default {
  name: 'Url',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    getValidationErrorText,
    invalidFields: [],
    securityEvidenceDetails: {
      infoLocatedUrl: '',
      accessInfo: '',
      informationExamined: '',
    },
  }),
  validations: {
    securityEvidenceDetails: {
      infoLocatedUrl: {
        required,
        url,
      },
      accessInfo: {
        required,
        maxLength: maxLength(4000),
        EMOJI,
      },
      informationExamined: {
        required,
        maxLength: maxLength(4000),
        EMOJI,
      },
    },
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (!ServicesModule.statement.securityEvidenceDetails) return;

      const statementStore = cloneDeep(
        ServicesModule.statement.securityEvidenceDetails
      );

      if (statementStore.infoLocatedUrl) {
        this.securityEvidenceDetails = statementStore;
      }
    },

    assemblyModel() {
      return {
        ...this.securityEvidenceDetails,
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: SecuringEvidenceStep.URL,
      });
    },
  },
};
</script>
